import { useEffect, useState } from 'react';
import { auth } from '../../firebase';
import { getFinancialAccess, hydrateFinancialRecords } from './financialService';
import { canReadFinancialKind } from './financialBoundary';

// Financial-only components opt into this reader; operational hooks never merge
// private values into the Planner/Worker/Pulse shared data cache.
export default function useFinancialView(kind, rows) {
  const [state, setState] = useState({ rows: [], authorized: false, loading: true, error: null });
  const uid = auth.currentUser?.uid;
  useEffect(() => {
    let current = true;
    setState({ rows: [], authorized: false, loading: true, error: null });
    (async () => {
      const access = await getFinancialAccess();
      const authorized = canReadFinancialKind(access, kind);
      const hydrated = authorized ? await hydrateFinancialRecords(kind, rows, access) : [];
      if (current && uid === auth.currentUser?.uid) setState({ rows: hydrated, authorized, loading: false, error: null });
    })().catch(error => { if (current) setState({ rows: [], authorized: false, loading: false, error }); });
    return () => { current = false; };
  }, [kind, rows, uid]);
  return state;
}
